export function accordionItem(item) {
  const accordionItem = `
  <div data-component="accordion" class="mb-7 block" aria-label="Dropdown" role="tab">
    <span class="visually-hidden">Tryk på mellemrumstasten for at akrivere dropdown</span>
    <label for="@item.Key" class="visually-hidden">Dropdown</label>
    <input id="@item.Key" type="checkbox" class="peer visually-hidden">
    <div data-title="${item.content.properties.title}" class="border border-blue bg-blue-10 text-blue rounded-[100px] py-3 pl-4 pr-3 flex justify-between items-center hover:cursor-pointer relative"><h3>${item.content.properties.title}</h3><svg class="lg:w-5 lg:h-5 w-7 h-7 ml-1 fill-blue"><use xlink:href="/spritemap.svg#sprite-dropdown"></use></svg></div>
    <div data-container="" class="overflow-hidden w-full mt-[-30px] h-0 transition-all duration-200">
        <div data-content="" class="inner-accordion border border-blue rounded-b-3xl border-t-0 pt-16 pb-8">
            <div class="prose px-5">
              ${item.content.properties.description.markup}
            </div>
        </div>
    </div>                                         
  </div>
  `;
  return accordionItem;
}
